// 设备型号
export enum EDeviceVersion {
  noScreen1 = '1',
  noScreen2 = '2',
  hasScreen = '5'
}